import script from "./expenseRatio.vue?vue&type=script&setup=true&lang=js"
export * from "./expenseRatio.vue?vue&type=script&setup=true&lang=js"

import "./expenseRatio.vue?vue&type=style&index=0&id=61e15d52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e15d52"]])

export default __exports__